import React from "react";
import i18n from "../../../../i18n";
import cookieManager from "../../../../utils/cookieManager";
import axios from "axios";
import PurchaseRequestActions from "../../../../reducers/modules/purchasing/purchase-request/actions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Navigate } from "react-router-dom";

const MySwal = withReactContent(Swal);
const url = process.env.REST_URL + "purchasing/purchasereq";

export default class PurchaseRequestMiddleware {
  static create() {
    return (dispatch) => {
      dispatch(PurchaseRequestActions.create());
    };
  }

  static update(params) {
    return (dispatch) => {
      dispatch(PurchaseRequestActions.update());
      PurchaseRequestMiddleware.showOne(dispatch, params);
    };
  }

  static list(params) {
    return (dispatch) => {
      dispatch(PurchaseRequestActions.process());
      PurchaseRequestMiddleware.showlist(dispatch, params);
    };
  }
  static resetList() {
    return (dispatch) => {
      dispatch(PurchaseRequestActions.resetList());
    };
  }
  static reset() {
    return (dispatch) => {
      dispatch(PurchaseRequestActions.reset());
    };
  }
  static getOne(params) {
    return (dispatch) => {
      dispatch(PurchaseRequestActions.view());
      PurchaseRequestMiddleware.showOne(dispatch, params);
    };
  }
  static getPrint(params) {
    return (dispatch) => {
      dispatch(PurchaseRequestActions.beforePrint());
      PurchaseRequestMiddleware.showPrint(dispatch, params);
    };
  }

  static beforeSaveNew(post, search) {
    return (dispatch) => {
      dispatch(PurchaseRequestActions.submit());
      PurchaseRequestMiddleware.saveNew(dispatch, post, search);
    };
  }
  static beforeApprove(id, value, search) {
    const post = {
      id: id,
      value: value,
    };
    return (dispatch) => {
      dispatch(PurchaseRequestActions.approve());
      PurchaseRequestMiddleware.saveApprove(dispatch, post, search);
    };
  }
  static beforeReject(id, value, search) {
    const post = {
      id: id,
      value: value,
    };
    return (dispatch) => {
      dispatch(PurchaseRequestActions.reject());
      PurchaseRequestMiddleware.saveReject(dispatch, post, search);
    };
  }
  static beforeSaveUpdate(params, post, search) {
    return (dispatch) => {
      dispatch(PurchaseRequestActions.submit());
      PurchaseRequestMiddleware.saveUpdate(dispatch, params, post, search);
    };
  }
  static beforeDelete(id, params) {
    return (dispatch) => {
      dispatch(PurchaseRequestActions.delete());
      PurchaseRequestMiddleware.delete(dispatch, params, id);
    };
  }

  static getHelper(params = null) {
    return (dispatch) => {
      PurchaseRequestMiddleware.showHelper(dispatch, params);
    };
  }

  static getHelperFull(params = null) {
    return (dispatch) => {
      PurchaseRequestMiddleware.showHelperFull(dispatch, params);
    };
  }

  static getToken() {
    return cookieManager.getUserToken();
  }

  static showHelperFull(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseRequestMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-purchasereq-helper",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PurchaseRequestActions.helperFull(response.data.result));
        }
      })
      .catch((error) => {
        PurchaseRequestMiddleware.alertHendler(dispatch, error);
      });
  }
  static showlist(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseRequestMiddleware.getToken()}`,
      },
      url: url,
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PurchaseRequestActions.list(response.data.result));
        }
      })
      .catch((error) => {
        PurchaseRequestMiddleware.alertHendler(dispatch, error);
      });
  }
  static showHelper(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseRequestMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-purchasereq",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PurchaseRequestActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        PurchaseRequestMiddleware.alertHendler(dispatch, error);
      });
  }
  static showOne(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseRequestMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PurchaseRequestActions.view(response.data.result));
        }
      })
      .catch((error) => {
        PurchaseRequestMiddleware.alertHendler(dispatch, error);
      });
  }

  static showPrint(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseRequestMiddleware.getToken()}`,
      },
      url: url + "/print/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PurchaseRequestActions.print(response.data.result));
        }
      })
      .catch((error) => {
        const data=error.response.data;
        switch(data.message){
          case 'Limit':
            dispatch(PurchaseRequestActions.limitPrint());
            const html=<><div>{i18n.t("Enter your message")}</div></>
            MySwal.fire({  
              title:i18n.t("Request to Print"),
              icon:false,
              html:html,
              input: 'textarea',
              inputValue: '',
              showCancelButton: false,  
              showConfirmButton: true,  
              allowOutsideClick: false,
              allowEscapeKey: false,
              inputValidator: (value) => {
                  if (!value) {
                  return i18n.t("You need to write something!")
                  }
              },
                allowOutsideClick: false,
                allowEscapeKey: false,
              }).then((result) => {
                if (result.isConfirmed) {
                    const value= result.value
                    MySwal.fire({
                        title:i18n.t('Proccessing Data'),
                        html:i18n.t('Please Wait ....'),
                        icon:'info',
                    })
                    MySwal.showLoading()
                    PurchaseRequestMiddleware.sendRequest(dispatch,value,params);
                }
            });   
            return;
          break;
          case 'Reject':
            dispatch(PurchaseRequestActions.limitPrint());
            const htmlreject=<><div className="text-danger">{i18n.t("Your Request Before is Rejected reason :") +' '+ data.error +' '+ i18n.t(", Please Create a new Request")}</div><div>{i18n.t("Enter your message")}</div></>
            MySwal.fire({  
              title:i18n.t("Request to Print"),
              icon:false,
              html:htmlreject,
              input: 'textarea',
              inputValue: '',
              showCancelButton: false,  
              showConfirmButton: true,  
              allowOutsideClick: false,
              allowEscapeKey: false,
              inputValidator: (value) => {
                  if (!value) {
                  return i18n.t("You need to write something!")
                  }
              },
                allowOutsideClick: false,
                allowEscapeKey: false,
              }).then((result) => {
                if (result.isConfirmed) {
                    const value= result.value
                    MySwal.fire({
                        title:i18n.t('Proccessing Data'),
                        html:i18n.t('Please Wait ....'),
                        icon:'info',
                    })
                    MySwal.showLoading()
                    PurchaseRequestMiddleware.sendRequest(dispatch,value,params);
                }
            });   
            return;
            break;
          case 'Waiting':
            dispatch(PurchaseRequestActions.saveRequestPrint());
            return;
          case 'Not Found':
              dispatch(PurchaseRequestActions.limitPrint());
              MySwal.fire({
                title:i18n.t('Data Not Found'),
                html:i18n.t('we cant found your request'),
                icon:'error',
            }).then(()=>{
              window.close()
            })
              return;
            break;
            default:
              PurchaseRequestMiddleware.alertHendler(dispatch, error);
              break;
        }
        
      });
  }
  static sendRequest(dispatch,value,params){
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseRequestMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "log/print/request",
      responseType: "json",
      data:{
        id:params,
        description:value,
        type:1
      }
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PurchaseRequestActions.saveRequestPrint());
          PurchaseRequestMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Request To print",
            "success"
          );
        }
      })
      .catch((error) => {
      })
  }
  static delete(dispatch, params, id) {
    axios({
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseRequestMiddleware.getToken()}`,
      },
      url: url + "/" + id,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            PurchaseRequestActions.process(),
            PurchaseRequestMiddleware.showlist(dispatch, params)
          );
          PurchaseRequestMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Delete Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        PurchaseRequestMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static saveNew(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseRequestMiddleware.getToken()}`,
      },
      url: url,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            PurchaseRequestActions.process(),
            PurchaseRequestMiddleware.showlist(dispatch, search)
          );
          dispatch(PurchaseRequestActions.success());
          PurchaseRequestMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Create Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        PurchaseRequestMiddleware.alertHendler(dispatch, error);
      });
  }
  static saveApprove(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseRequestMiddleware.getToken()}`,
      },
      url: url + "/approve/" + post.id,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            PurchaseRequestActions.process(),
            PurchaseRequestMiddleware.showlist(dispatch, search)
          );
          dispatch(PurchaseRequestActions.success());
          PurchaseRequestMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Approve Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        PurchaseRequestMiddleware.alertHendler(dispatch, error, true);
      });
  }
  static saveReject(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseRequestMiddleware.getToken()}`,
      },
      url: url + "/reject/" + post.id,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            PurchaseRequestActions.process(),
            PurchaseRequestMiddleware.showlist(dispatch, search)
          );
          dispatch(PurchaseRequestActions.success());
          PurchaseRequestMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Reject Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        PurchaseRequestMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static saveUpdate(dispatch, params, post, search) {
    axios({
      method: "PUT",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${PurchaseRequestMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            PurchaseRequestActions.process(),
            PurchaseRequestMiddleware.showlist(dispatch, search)
          );
          dispatch(PurchaseRequestActions.success());
          PurchaseRequestMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Update Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        PurchaseRequestMiddleware.alertHendler(dispatch, error);
      });
  }
  static alertHendler(
    dispatch,
    result,
    isSwal = false,
    extraMessage = "",
    type = "error"
  ) {
    if (type == "error") {
      if (result.response) {
        const status = result.response.status;
        switch (status) {
          case 500:
            if (isSwal) {
              const data = result.response.data;
              MySwal.hideLoading();
              MySwal.update({
                title: "Delete Error",
                html: data.error,
                icon: "error",
                showConfirmButton: true,
              });
            } else {
              const data = result.response.data;
              dispatch(PurchaseRequestActions.error(data.error));
            }
            break;
          case 403:
            console.log("Error 403");
            break;
          case 404:
            console.log("Error 404");
            break;
          case 401:
            const data = result.response.data;
            MySwal.fire({
              title: "Login Invalid",
              html: data.error,
              icon: "error",
              showConfirmButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                <Navigate to="/login"></Navigate>;
              }
            });
            break;
        }
      } else if (result.request) {
        MySwal.fire({
          title: "Internal Server Error",
          html: "Please info your Developer to fix this",
          icon: "error",
          showConfirmButton: true,
        });
        dispatch(PurchaseRequestActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", result.message);
      }
    } else {
      MySwal.fire({
        title: "Success",
        html: extraMessage,
        icon: "success",
        showConfirmButton: true,
      });
    }
  }
}
